import { render, staticRenderFns } from "./ExpertSTable.vue?vue&type=template&id=06eaf3ec"
import script from "./ExpertSTable.vue?vue&type=script&lang=js"
export * from "./ExpertSTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports